"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.videoPause = void 0;
var util_1 = require("./util");
var videoPause = function (event) {
    return (0, util_1.videoEvent)(event, "video-pause");
};
exports.videoPause = videoPause;
